<template>
  <div class="body">
    <el-container>
      <!-- <ReportsAside /> -->
      <el-main>
        <button
          v-show="1 == 0"
          v-shortkey="['f3']"
          @shortkey="showHiden = !showHiden"
        ></button>
        <div class="mt-2">
          <el-row :gutter="10">
            <el-col :xl="3" :lg="3" :md="6" :sm="12">
              <div class="bg-White p-3">
                <el-input
                  @change="selectSearchCode"
                  placeholder="بحث بالفاتورة "
                  autofocus
                  type="text"
                  @focus="$event.target.select()"
                  v-model="searchCode"
                ></el-input>
              </div>
            </el-col>
            <el-col :xl="10" :lg="10" :md="6" :sm="12">
              <div class="bg-White p-3">
                <SearchCustomers
                  :searchOnly="true"
                  :customer="customer"
                  @selectedCustomer="selectedCustomer"
                  :productsLength="productsLength"
                  :productSearch="false"
                  :showLabel="false"
                />
              </div>
            </el-col>
            <el-col :xl="9" :lg="9" :md="6" :sm="12">
              <div class="bg-White p-3">
                <el-date-picker
                  @change="selectDateRange"
                  v-model="dateRange"
                  type="daterange"
                  range-separator="الي"
                  format="yyyy/MM/dd"
                  value-format="yyyy-MM-dd"
                  start-placeholder="بداية الفترة"
                  end-placeholder="نهاية الفترة"
                  style="width: 100%"
                >
                </el-date-picker>
              </div>
            </el-col>
            <el-col
              :xl="2"
              :lg="2"
              :sm="12"
              v-if="accessLinks('print_returned_sale_bill')"
            >
              <div class="bg-White p-3">
                <el-button
                  type="success"
                  title="طباعه"
                  icon="el-icon-printer"
                  @click="sendToPrintAll(tableData)"
                ></el-button>
              </div>
            </el-col>
          </el-row>
          <customer-info
            :customer="customer"
            :type="'customer'"
            v-if="customer != null"
          />
        </div>
        <el-row :gutter="10" v-if="showHiden">
          <el-col :xl="24" :lg="24" :md="6" :sm="12">
            <el-button type="success">
              المبيعات بسعر الشراء |
              {{ numberToFixed(buyCost) }}</el-button
            >
            <el-button type="primary" class="mr-2">
              المبيعات بسعرالبيع |
              {{ numberToFixed(saleCost) }}</el-button
            >
            <el-button type="danger" class="mr-2">
              الخصومات|
              {{ numberToFixed(totalDiscount) }}</el-button
            >
            <el-button type="warning" class="mr-2 mt-2">
              الربح |
              {{ numberToFixed(saleCost - buyCost - totalDiscount) }}</el-button
            >
          </el-col>
        </el-row>
        <el-table
          class="mt-2"
          align="right"
          v-if="tableData.length > 0"
          :data="tableData"
          border
          style="overflow: auto; width: 100%"
        >
          <el-table-column label="#" type="index" width="50"> </el-table-column>
          <el-table-column sortable width="100" label="الفاتورة" prop="id">
          </el-table-column>
          <el-table-column label="القيمة" prop="total_cost"> </el-table-column>
          <el-table-column label="الخصم" prop="discount"> </el-table-column>
          <el-table-column label="الاجمالي" prop="total"> </el-table-column>
          <el-table-column width="180" label="العميل" prop="customer.name">
          </el-table-column>
          <el-table-column label="بواسطة" prop="user.name"> </el-table-column>
          <el-table-column
            width="170"
            sortable
            label="التوقيت"
            prop="created_at"
          >
            <template slot-scope="scope">
              {{ scope.row.created_at | moment("Do / MM / YYYY | h:mm A") }}
            </template>
          </el-table-column>
          <el-table-column
            label="اجراءات"
            width="80"
            v-if="accessLinks('print_returned_sale_bill')"
          >
            <template slot-scope="scope">
              <el-button
                type="success"
                size="mini"
                title="طباعه"
                icon="el-icon-printer"
                @click="sendToPrint(scope.row)"
              ></el-button>
            </template>
          </el-table-column>
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table
                class="mt-2"
                align="right"
                :data="props.row.products"
                border
                style="width: 80%; margin: auto"
              >
                <el-table-column label="#" type="index" width="50">
                  <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                  </template>
                </el-table-column>
                <el-table-column label="المنتج " prop="name"></el-table-column>
                <el-table-column
                  sortable
                  width="100"
                  label="الكمية "
                  prop="pivot.qty"
                >
                </el-table-column>
                <el-table-column
                  width="100"
                  label="السعر "
                  prop="pivot.sale_price"
                ></el-table-column>
                <el-table-column label="الاجمالي">
                  <template slot-scope="scope">
                    {{ scope.row.pivot.qty * scope.row.pivot.sale_price }}
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
        </el-table>
        <el-row>
          <el-col :span="24">
            <el-button
              style="width: 100%"
              v-if="tableData.length > 0 && pagination.last_page > 1"
              @click="loadMoreData"
              icon="el-icon-caret-bottom"
              >تحميل المزيد</el-button
            >
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import axiosApi from "@/plugins/axios.js";
// import ReportsAside from "@/components/ReportsAside.vue";
import SearchCustomers from "@/components/Customers/SearchWithoutAdd.vue";
// import { ipcRenderer } from "electron";
import CustomerInfo from "../../components/CustomerInfo.vue";

export default {
  name: "Products",

  components: { SearchCustomers, CustomerInfo },

  data() {
    return {
      showHiden: false,
      buyCost: 0,
      totalDiscount: 0,
      saleCost: 0,
      true: true,
      productsLength: 0,
      customer: null,
      dateRange: null,
      editFormVisible: false,
      tableData: [],
      selectedProduct: null,
      productCategories: [],
      name: "",
      searchCode: "",
      selectedCategory: "",
      current_page: 1,
      page_limit: 1,
      pagination: {
        current_page: 1,
        last_page: 1,
      },
      filterMode: false,
    };
  },
  created() {
    this.getSales();
  },
  methods: {
    sendToPrint(row) {
      console.log("row", row);
      // window.ipcRenderer = ipcRenderer;
      // let data = {
      //   data: row,
      //   type: "saleInvoice",
      //   title: "مرتجع مبيعات",
      //   invoiceType: "return",
      //   img:
      //     "https://pos.staging.fatura-app.com" +
      //     JSON.parse(localStorage.getItem("branch")).logo,
      // };
      // ipcRenderer.send("printing", data);
    },
    sendToPrintAll(row) {
      // window.ipcRenderer = ipcRenderer;
      let data = {
        data: row,
        type: "allReports",
        title: " مرتجع مبيعات ",
        img:
          "https://pos.staging.fatura-app.com" +
          JSON.parse(localStorage.getItem("branch")).logo,
      };
      console.log("🚀 ~ sendToPrintAll ~ data:", data)
      // ipcRenderer.send("printing", data);
    },
    selectedCustomer(e) {
      this.customer = e.customer;
      this.filterMode = true;
      this.getSales();
    },
    selectSearchCode() {
      this.filterMode = true;
      this.getSales();
    },
    selectDateRange() {
      this.filterMode = true;
      this.getSales();
    },
    numberToFixed(number) {
      return Number(number).toFixed(2);
    },
    deleteInvoice(invoice) {
      // alert(invoice.row.id);
      const loading = this.$loading({
          lock: true,
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
      });

      axiosApi
        .delete(`sales/${invoice.row.id}`)
        .then(() => {
          this.getSales();
          this.$notify({
            title: "تمت العملية بنجاح",
            message: "تم حذف فاتورة المبيعات بنجاح",
            type: "success",
            duration: 1500,
          });
        })
        .catch((e) => {
          this.$notify.error({
            title: "حدث خطأ",
            message: "حدث خطأ",
            duration: 1500,
          });
          console.log(e);
        })
        .finally(() => loading.close());
    },
    loadMoreData() {
      if (this.pagination.last_page > this.pagination.current_page) {
        this.pagination.current_page++;
        this.getSales();
      }
    },
    getSales() {
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      if (this.filterMode) {
        this.pagination.current_page = 1;
        this.tableData = [];
      }
      this.getSalesCost();
      let url = `returned-sales/${
        JSON.parse(localStorage.getItem("user_inventories"))[0].id
      }?page=${this.pagination.current_page}`;
      if (this.dateRange != null) {
        url += "&start=" + this.dateRange[0];
        url += "&end=" + this.dateRange[1];
      }
      if (this.searchCode.trim() != "") {
        url += "&code=" + this.searchCode;
      }
      if (this.customer != null) {
        url += "&customer=" + this.customer.id;
      }
      axiosApi
        .get(url)
        .then((res) => {
          console.log(res);
          res.data.data.map((item) => {
            this.tableData.push(item);
          });
          this.pagination = res.data.meta;

          this.tableData.map((invoice) => {
            invoice.total = this.numberToFixed(
              invoice.total_cost - invoice.discount
            );
            invoice.total_cost = this.numberToFixed(invoice.total_cost);
            invoice.discount = this.numberToFixed(invoice.discount);
          });
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          loading.close();
          this.filterMode = false;
        });
    },
    async getSalesCost() {
      // let loader = this.$loading.show({});
      let link = `returned-sales/${
        JSON.parse(localStorage.getItem("user_inventories"))[0].id
      }?limit=20`;
      if (this.dateRange != null) {
        link += "&start=" + this.dateRange[0];
        link += "&end=" + this.dateRange[1];
      }
      if (this.searchCode != "") {
        link += "&id=" + this.searchCode.trim();
      }
      if (this.customer != null) {
        link += "&customer_id=" + this.customer.id;
      }
      await axiosApi
        .get(link)
        .then((res) => {
          console.log("========== res.data =========", res.data);
          this.buyCost = res.data["sales"].buyCost;
          this.saleCost = res.data["sales"].saleCost;
          this.totalDiscount = res.data["discounts"].totalDiscount;
        })
        .catch((e) => {
          console.log(e);
        })
        .finally(() => {
          // loader.hide();
        });
    },
    accessLinks(link) {
      let permissionNames = JSON.parse(localStorage.getItem("permissionNames"));
      return permissionNames.includes(link);
    },
  },
};
</script>

<style scoped>
.el-table {
  width: 100%;
  max-height: 80%;
  overflow-y: scroll;
}
</style>
